import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SAVE: `${cleanedFilename(__filename)}-save`,
  CANCEL: `${cleanedFilename(__filename)}-cancel`,
  OFFICE_DROPDOWN: `${cleanedFilename(__filename)}-office-dropdown`,
};
